import { App } from '@ps20-frontend/frontend-models';
import { SicherungsglaeubigerV10, StatePreV10, StateV10 } from './10_sigl_interfaces';

export const sicherungsglaeubiger = (previousState: StatePreV10, newVersion: number): StateV10 => {
  const vwgProdukt = previousState.produkte.find(value => value.produktId === App.VWG);
  if (vwgProdukt) {
    const siglArray: Array<SicherungsglaeubigerV10> = previousState.sicherungsglaeubiger.map(
      (value, index) => {
        return { ...value, index, angebotsId: vwgProdukt.angebotsId };
      },
    );
    return {
      ...previousState,
      version: newVersion,
      sicherungsglaeubiger: siglArray,
    };
  }
  return { ...previousState, version: newVersion, sicherungsglaeubiger: [] };
};
